export default {"src":"/_next/static/media/seatsIcon.2588b158.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};